import { AxiosError } from 'axios';
import instance from '../config/axios';

export const createWishList = async (token: string, productId: number) => {
  try {
    const response = await instance.post(
      '/api/v1/add/whislist-product',
      { productId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
